import React, { useCallback } from 'react';
import { Col, ListGroup, Row, Media } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { SafetyImage } from '../../common/SafetyImage';
import { ProgramRequestLike } from './ProgramRequestLike';

import './program-request-item.css';

export function ProgramRequestItem(props) {
    const { item, inGroup } = props;
    const isRequest = !!item.requestNum;
    const [mediaSizeSm, mediaSizeMd, textSizeSm, textSizeMd] = isRequest ? [5, 3, 5, 8] : [2, 1, 10, 11];
    const navigate = useNavigate();
    const handleRequestItemClick = useCallback(() => {
        if (isRequest) navigate(`request/${item.requestNum}`);
    }, [navigate, isRequest, item.requestNum]);
    return (
        <ListGroup.Item
            className={`${isRequest && 'program-request-item'} py-2 ${inGroup ? ' pl-0' : ''}`}
            onClick={handleRequestItemClick}
        >
            <div className="d-flex">
                <div className="flex-grow-1">
                    <Row className="align-items-center">
                        <Col xs={8} sm={mediaSizeSm} md={mediaSizeMd}>
                            {(isRequest || item.thumbnail) && (
                                <Media className="align-items-center">
                                    <SafetyImage
                                        width={64}
                                        height={64}
                                        src={item.thumbnail}
                                        alt=""
                                        className="border rounded p-1"
                                        lazyLoad
                                    />
                                    <Media.Body className="text-center">
                                        <div className="h5 mb-0">{item.requestNum}</div>
                                        {(!inGroup && item.nominationShort) || ''}
                                    </Media.Body>
                                </Media>
                            )}
                        </Col>
                        <Col sm={textSizeSm} md={textSizeMd}>
                            <Row>
                                <Col xs={12} lg={item.participant ? 7 : 12}>
                                    {item.title}
                                </Col>
                                {item.participant && (
                                    <Col xs={12} lg={5}>
                                        {item.participant}
                                    </Col>
                                )}
                            </Row>
                        </Col>
                        {isRequest && (
                            <Col sm={2} md={1} className="request-like">
                                <ProgramRequestLike requestId={item.requestId} />
                            </Col>
                        )}
                    </Row>
                </div>
                <div
                    className={`request-item-time align-self-start align-self-sm-center ${
                        isRequest && 'this-is-request'
                    }`}
                >
                    {item.startTime}
                </div>
            </div>
        </ListGroup.Item>
    );
}
